import React from 'react';
import OverviewContent from '../function-components/OverviewContent';

function Overview() {
    return (
        <>
            <OverviewContent />
        </>
    )
}

export default Overview